import styled, { css } from 'styled-components'

export const FormCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FormModalHost = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  overflow: visible;
  pointer-events: none;

  .rankmi-modal-host {
    pointer-events: auto;
  }
`

export const FormRoot = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
`

export const Field = styled.div<{ $halfWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: ${({ $halfWidth }) => ($halfWidth ? '50%' : '100%')};
  min-width: 0;

  label {
    margin-bottom: 0;
  }
`

export const FieldControl = styled.div<{ $hasError?: boolean }>`
  width: 100%;

  .ant-input {
    border-width: 2px;
    border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#d9d9d9')};

    &:hover,
    &:focus {
      border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#40a9ff')};
      box-shadow: none;
    }
  }

  .ant-select > div,
  .ant-select-selection {
    border: 2px solid ${({ $hasError }) => ($hasError ? '#f5222d' : '#d9d9d9')} !important;
  }

  .ant-select > div:hover,
  .ant-select > div:focus,
  .ant-select-open > div,
  .ant-select-focused > div,
  .ant-select-open .ant-select-selection,
  .ant-select-focused .ant-select-selection {
    border-color: ${({ $hasError }) =>
      $hasError ? '#f5222d' : '#40a9ff'} !important;
    box-shadow: none;
  }
`

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 8px;
    border: none;
    border-radius: 8px;
    background: #f0f0f0;
    color: #4c4c4c;
    cursor: pointer;

    &:hover {
      color: #213f68;
      background: rgba(158, 207, 250, 0.25);
    }
  }

  h2 {
    margin: 0;
    color: #002a6d;
    font-family: Roboto, sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }
`

export const SectionPanel = styled.div<{ $hideBorder?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #d9d9d9;

  ${({ $hideBorder }) =>
    $hideBorder &&
    css`
      padding-bottom: 32px;
      border-bottom: none;
    `}
`

export const SectionTitle = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: none;
  background: transparent;
  color: #002a6d;
  font-family: Roboto, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  cursor: pointer;
  text-align: left;

  svg {
    width: 16px;
    color: #002a6d;
  }
`

export const SectionDescription = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const InfoBanner = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #f5f5f5;
  color: #363636;
  word-break: break-word;
`

export const InfoBannerIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  color: #363636;

  svg {
    width: 14px;
    height: 14px;
  }
`

export const InfoBannerContent = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const InfoBannerText = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  strong {
    font-weight: 700;
  }
`

export const Dc4FieldsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #ffffff;
`

export const SignerBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SignerTitle = styled.h3`
  margin: 0;
  color: #213f68;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`

export const SignerRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;

  > * {
    width: 100%;
    min-width: 0;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const HelperText = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  color: #002a6d;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  line-height: 16px;

  svg {
    width: 12px;
    margin-top: 2px;
  }
`

export const FormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  .actions {
    display: flex;
    gap: 8px;
    margin-left: auto;
  }

  button {
    height: 40px;
    padding: 0 12px;
    border: none;
    border-radius: 8px;
    font-weight: 700;
    cursor: pointer;
  }

  .preview {
    color: #4c4c4c;
    background: #f0f0f0;
  }

  .cancel {
    color: #4c4c4c;
    background: #f0f0f0;
  }

  .save {
    color: #fff;
    background: #2684ff;
  }

  button:disabled {
    opacity: 0.48;
    cursor: not-allowed;
  }
`

export const RetroactiveWarningBanner = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  background: #fffbe6;
  color: #363636;
  word-break: break-word;
`

export const RetroactiveWarningIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  color: #faad14;

  svg {
    width: 14px;
    height: 14px;
  }
`

export const RetroactiveWarningContent = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const RetroactiveWarningText = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  strong {
    font-weight: 700;
  }
`
